import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import styles from './DropdownContainer.module.scss';
import clsx from 'clsx';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

interface DropdownContainerProps extends PropsWithChildren {
    header?: ReactNode;
    footer: ReactNode;
    className?: string;
}

export const DropdownContainer: FunctionComponent<DropdownContainerProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            {props.header && <div className={styles.header}>{props.header}</div>}
            <div className={styles.body}>
                <OverlayScrollbarsComponent style={{ height: '195px', padding: '0px 20px' }}>
                    {props.children}
                </OverlayScrollbarsComponent>
            </div>
            <div className={styles.footer}>{props.footer}</div>
        </div>
    );
};

export default DropdownContainer;
